import { useNotification } from "@itandi/itandi-bb-ui/NotificationBarStore";
import React from "react";
import { useSWRConfig } from "swr";
import { ConfirmModal } from "~/components/common/parts/modal/ConfirmModal";
import { useDealContext } from "~/context/DealContext";
import { dealCacheKey } from "~/hooks/useDeals";
import useItandiAccount from "~/hooks/useItandiAccount";
import { useOpenHandler } from "~/hooks/useOpenHandler";
import { hasPermissionToOperateDeal } from "~/models/Staff";
import { isSuccess } from "~/utils/api/api_handler";
import { create as postCancelBack } from "~/utils/api/deals/DealCancelBack";
import Styles from "./statuses.module.scss";

export const Canceled: React.FC = () => {
	const { notify } = useNotification();
	const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
	const deal = useDealContext();
	const { mutate: globalMutate } = useSWRConfig();
	const {
		isOpen: confirmBackOpen,
		handleOpen: handleConfirmBackOpen,
		handleClose: handleConfirmBackClose
	} = useOpenHandler();
	const { data } = useItandiAccount().currentAccount();
	if (deal === null || data === null) {
		return null;
	}
	const { dealCancel } = deal;
	const handleDeleteCancel = async (): Promise<void> => {
		const result = await postCancelBack(deal.id);
		if (isSuccess(result)) {
			await globalMutate(dealCacheKey(deal.id));
			notify({
				content: "取り下げた案件を元に戻しました。",
				variant: "success"
			});
			handleConfirmBackClose();
			return;
		}
		notify({ content: "エラーが発生しました。", variant: "error" });
		setIsSubmitting(false);
	};
	return (
		<div>
			<h3 className={Styles.Title}>この案件は取り下げられました</h3>
			{dealCancel !== null && (
				<div>
					<div className={Styles.CancelReasonLabel}>取り下げ理由</div>
					<div className={Styles.CancelReason}>{dealCancel.reason}</div>
				</div>
			)}
			<div className={Styles.StatusHandleButtonRow}>
				<div className={Styles.RightButtons}>
					<button
						className={Styles.BackwardButton}
						disabled={!hasPermissionToOperateDeal(data)}
						onClick={handleConfirmBackOpen}
						type="button"
					>
						案件を元に戻す
					</button>
				</div>
				<ConfirmModal
					actionText="元に戻す"
					confirmType="save"
					disabled={isSubmitting}
					handleAccept={handleDeleteCancel}
					handleCancel={handleConfirmBackClose}
					isOpen={confirmBackOpen}
				>
					取り下げた案件を元に戻しますか？
				</ConfirmModal>
			</div>
		</div>
	);
};
